import React, { CSSProperties, FC } from 'react';

const svgElementStyle: CSSProperties = {
  pointerEvents: 'none',
};

export const DragIconSvg: FC = () => (
  <svg
    style={svgElementStyle}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7 15.5C7 14.6716 6.32843 14 5.5 14C4.67157 14 4 14.6716 4 15.5C4 16.3284 4.67157 17 5.5 17C6.32843 17 7 16.3284 7 15.5Z"
      fill="currentColor"
    />
    <path
      d="M13 15.5C13 14.6716 12.3284 14 11.5 14C10.6716 14 10 14.6716 10 15.5C10 16.3284 10.6716 17 11.5 17C12.3284 17 13 16.3284 13 15.5Z"
      fill="currentColor"
    />
    <path
      d="M17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14Z"
      fill="currentColor"
    />
    <path
      d="M7 9.5C7 8.67157 6.32843 8 5.5 8C4.67157 8 4 8.67157 4 9.5C4 10.3284 4.67157 11 5.5 11C6.32843 11 7 10.3284 7 9.5Z"
      fill="currentColor"
    />
    <path
      d="M11.5 8C12.3284 8 13 8.67157 13 9.5C13 10.3284 12.3284 11 11.5 11C10.6716 11 10 10.3284 10 9.5C10 8.67157 10.6716 8 11.5 8Z"
      fill="currentColor"
    />
    <path
      d="M19 9.5C19 8.67157 18.3284 8 17.5 8C16.6716 8 16 8.67157 16 9.5C16 10.3284 16.6716 11 17.5 11C18.3284 11 19 10.3284 19 9.5Z"
      fill="currentColor"
    />
  </svg>
);
